import { SortOrder } from '@Utils/helpers/sortingHelpers';
import { GeoserverFeaturesResponse } from '@Data/geoserver/Interfaces';
import {
    GetSpansResponse,
    IAnalysisEntity,
    IQcPole,
    IQcSpanEntity,
    IQcStatusOption,
    IReworkReasonStage,
    ISelectedPoleAttachedSpan,
    ImageIndex,
    QcPhotoPosition,
    QualityControlState,
    TableSortField,
} from './Interfaces';

export interface IQualityControlState {
    geoserverData: GeoserverFeaturesResponse;

    rawData: GetSpansResponse;

    inspectionStartDate: string;
    state: QualityControlState;
    analysisEntities: IAnalysisEntity[];
    selectedAnalysisEntity: IAnalysisEntity;

    tableSortField: TableSortField;
    tableSortOrder: SortOrder;

    backPole: IQcPole;
    backSpan: IQcSpanEntity;
    centrePole: IQcPole;
    foreSpan: IQcSpanEntity;
    forePole: IQcPole;

    selectedPoleAdjacentSpans: ISelectedPoleAttachedSpan[];
    allAttachedSpans: ISelectedPoleAttachedSpan[];
    forespanIndex: number;
    backspanIndex: number;

    currentFullSpanData: any;
    imageIndices: [ImageIndex, ImageIndex, ImageIndex, ImageIndex, ImageIndex];
    areImagesLoading: [boolean, boolean, boolean, boolean, boolean];

    reworkStages: IReworkReasonStage[];

    qcStatusOptions: IQcStatusOption[];
}

export const initialQualityControlState: IQualityControlState = {
    geoserverData: null,
    rawData: null,

    inspectionStartDate: '',
    state: QualityControlState.PENDING,
    analysisEntities: null,
    selectedAnalysisEntity: null,

    tableSortField: TableSortField.NONE,
    tableSortOrder: SortOrder.DESC,

    backPole: {
        entityVersionId: null,
        photoPosition: QcPhotoPosition.BACKPOLE,
        truesizeImageUrls: [],
        truesizeImageInfo: [],
        poletagImageUrls: [],
        poletagLoadedImageUrl: null,
        backwardLabels: [],
        forwardLabels: [],
        title: null,
        equipment: [],
        anchors: [],
    },
    backSpan: {
        photoPosition: QcPhotoPosition.BACKSPAN,
        truesizeImageUrls: [],
        truesizeImageInfo: [],
        backwardLabels: [],
        forwardLabels: [],
        title: null,
        bearing: null,
        span_id: null,
    },
    centrePole: {
        entityVersionId: null,
        photoPosition: QcPhotoPosition.CENTREPOLE,
        truesizeImageUrls: [],
        truesizeImageInfo: [],
        poletagImageUrls: [],
        poletagLoadedImageUrl: null,
        backwardLabels: [],
        forwardLabels: [],
        backwardNoHeightLabels: [],
        forwardNoHeightLabels: [],
        title: null,
        equipment: [],
        anchors: [],
    },
    foreSpan: {
        photoPosition: QcPhotoPosition.FORESPAN,
        truesizeImageUrls: [],
        truesizeImageInfo: [],
        backwardLabels: [],
        forwardLabels: [],
        title: null,
        bearing: null,
        span_id: null,
    },
    forePole: {
        entityVersionId: null,
        photoPosition: QcPhotoPosition.FOREPOLE,
        truesizeImageUrls: [],
        truesizeImageInfo: [],
        poletagImageUrls: [],
        poletagLoadedImageUrl: null,
        backwardLabels: [],
        forwardLabels: [],
        title: null,
        equipment: [],
        anchors: [],
    },

    selectedPoleAdjacentSpans: [],
    allAttachedSpans: [],
    forespanIndex: 0,
    backspanIndex: 0,

    currentFullSpanData: null,
    imageIndices: [0, 0, 0, 0, 0],
    areImagesLoading: [false, false, false, false, false],

    reworkStages: [],
    qcStatusOptions: [],
};
